<template>
    <v-container fluid>
        <div v-if="!loading">
            <v-row class="my-2 subtitle-2 secondary--text pl-12">
                Products
            </v-row>
            <v-divider />
            <!--table head-->
               <v-row class="subtitle-2" no-gutters>
                <v-col v-for="(item, i) in headers" :key="i" 
                    class="tabCell"
                    :class="item.style">
                    {{ item.title }}
                </v-col>
            </v-row>
            <div v-if="products?.length > 0">
                <!-- products tab -->
                <v-row v-for="product in products" :key="product.id" no-gutters>
                    <v-col class="tabCell text-left">{{ product.team?.name }}</v-col>
                    <v-col class="tabCell text-center">{{ product.trademark?.name }}</v-col>
                    <v-col class="tabCell text-center">{{ product.model }}</v-col>
                    <v-col class="tabCell text-center">{{ product.material }}</v-col>
                    <v-col class="tabCell text-center">{{ product.manufacturing }}</v-col>
                    <v-col class="tabCell text-center">{{ product.design_type }}</v-col>
                    <v-col class="tabCell text-center">{{ product.design }}</v-col>
                    <v-col class="tabCell text-center">{{ product.variations }}</v-col>
                    <v-col class="tabCell text-center">{{ product.advanced_feature }}</v-col>
                    <v-col class="tabCell text-center">{{ localeNumber(product.sales_plan) }}</v-col>
                    <v-col class="tabCell text-center">{{ localeNumber(product.production_plan) }}</v-col>
                    <v-col class="tabCell text-center">{{ product.retail_price }}</v-col>
                    <v-col class="tabCell text-center">{{ product.price }}</v-col>
                    <v-col class="tabCell text-center">{{ product.unit_cost }}</v-col>
                    <v-col class="tabCell text-center">
                        <edit-product :product="product" />
                        <delete-product :product="product" />
                    </v-col>
                </v-row>
            </div>
        </div>
    </v-container>
</template>
<script>
import EditProduct from '../../../components/admin/products/editProduct.vue';
import DeleteProduct from '../../../components/admin/products/deleteProduct.vue';
export default {
    data() {
        return {
            headers: [
                { title: 'team', style: 'text-left' },
                { title: 'trademark', style: 'text-center'},
                { title: 'model', style: 'text-center'},
                { title: 'material', style: 'text-center'},
                { title: 'manufacturing', style: 'text-center'},
                { title: 'type of design', style: 'text-center'}, 
                { title: 'design level', style: 'text-center'},
                { title: 'variations', style: 'text-center'},
                { title: 'advanced feature', style: 'text-center'}, 
                { title: 'sales plan', style: 'text-center'},
                { title: 'production plan', style: 'text-center'},
                { title: 'retail price', style: 'text-center'},
                { title: 'ex-work price', style: 'text-center'},
                { title: 'unit_cost', style: 'text-center'},
                { title: 'action', style: 'text-center' },
            ]
        }
    },
    computed: {
        loading() {
            return this.$store.getters.loading
        },
        locale() {
            return this.$store.getters.locale;
        },
        products() {
            return this.$store.getters.products_all;
        },
    },
    methods: {
        localeNumber(num) {
            if (this.locale == 'ro-RO') {
                return num.toLocaleString('en-US')
            }
            return num.toLocaleString(this.locale)
        }
    },
    components: {
        EditProduct, DeleteProduct
    }
}
</script>